module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/microphone-e48a8bb2f305fb72db78f934da81a7c3.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/microphone.svg
// module id = b1Na
// module chunks = 24